import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Testo del messaggio", -1)
const _hoisted_4 = {
  key: 0,
  class: "p-mb-3"
}
const _hoisted_5 = { class: "p-d-flex p-jc-around" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createBlock(_component_PDialog, _mergeProps({
    draggable: true,
    keepInViewPort: true,
    minX: 0,
    minY: 0,
    modal: true,
    class: "p-fluid",
    header: "Invia messaggio all'utente"
  }, _ctx.$attrs, { onShow: _ctx.onShow }), {
    footer: _withCtx(() => [
      (_ctx.requestPending)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              style: {"height":".5em"}
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          label: _ctx.$t('cancel'),
          loading: _ctx.requestPending,
          class: "p-button-info",
          icon: "pi pi-times",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:visible', false)))
        }, null, 8, ["label", "loading"]),
        _createVNode(_component_Button, {
          disabled: _ctx.requestPending,
          label: _ctx.$t('common.send'),
          icon: "pi pi-send",
          onClick: _ctx.send
        }, null, 8, ["disabled", "label", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.hint)
        ? (_openBlock(), _createElementBlock("h6", _hoisted_1, _toDisplayString(_ctx.hint), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_Textarea, {
          id: "message",
          modelValue: _ctx.message.text,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.message.text = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 16, ["onShow"]))
}